<template>
    <!-- 快來串門子的 更多 -->
    <div>
        <navigation-bar Back Bell/>
        <div class="main">
            <custom-card v-if="showHidden">
                <quick-menu/>
                <el-row>
                    <el-button type="text" class="tag-btn">#速食</el-button>
                    <el-button type="text" class="tag-btn">#日式美食</el-button>
                    <el-button type="text" class="tag-btn">#中式料理</el-button>
                    <el-button type="text" class="tag-btn">#美式美食</el-button>
                    <el-button type="text" class="tag-btn">#健康餐</el-button>

                    <el-button type="text" class="tag-btn">#義式料理</el-button>
                    <el-button type="text" class="tag-btn">#泰國美食</el-button>
                    <el-button type="text" class="tag-btn">#異國料理</el-button>
                    <el-button type="text" class="tag-btn">#南洋料理</el-button>
                    <el-button type="text" class="drop-down" icon="el-icon-arrow-down"></el-button>
                </el-row>
            </custom-card>
            <category-content>
                <article-cover :list="storeList" :showRemark="isShowRemark" :remark="getRemark" :shopType="'store'" hideStar>
                    <tag-list  v-if="showHidden" />
                </article-cover>
            </category-content>
            <infinite-loading @infinite="setupDataScroll" spinner="waveDots" v-if="setupData">
                <div slot="no-more">沒有更多資料</div>
                <span slot="no-results"/>
            </infinite-loading>
        </div>

        <loading
            :active.sync=isLoading
            :can-cancel="false"
            :is-full-page="true">
        </loading>
    </div>
</template>

<script>
    import CategoryContent from '@/components/category/Content.vue';
    import QuickMenu from '@/components/QuickMenu.vue'
    import CustomCard from '@/components/CustomCard.vue';
    import ArticleCover from '@/components/article/ArticleCover.vue'
    import TagList from '@/components/TagList.vue'

    export default {
        name: "Visit",
        components: {
            QuickMenu,
            CustomCard,
            CategoryContent,
            ArticleCover,
            TagList
        },
        data() {
            return {
                isLoading: false,
                storeList: [],

                pageSize: 10,
                currentPage: 0,
                setupData: false,
                showHidden: false,
                lng: 0,
                lat: 0,
            }
        },
        created() {
        },
        mounted() {
            //快來串門子
            let self = this;
            this.isLoading = true;
            let onSuccess = function (position) {
              self.lng = position.coords.longitude;
              self.lat = position.coords.latitude;
              self.setupData = true;
            };
            let onError = function (error) {
              self.lng = 0;
              self.lat = 0;
              self.setupData = true;
              self.$public.showNotify("code: " + error.code + ", message: " + error.message+"。無法定位GPS", false, 3000)
            };

            self.$public.getGpsLocation(onSuccess, onError);
        },
        methods: {
            setupDataScroll: function ($state) {
                //快來串門子
                let self = this;
                this.isLoading = true;

                self.$http.fetch`StoreList${{
                  searchType: 1,
                  offset: self.currentPage,
                  lng: self.lng,
                  lat: self.lat,
                }}
                 ${json => {
                  if (json.data.length >= this.pageSize) {
                    self.currentPage++;
                    self.storeList.push(...json.data);
                    $state.loaded();
                  } else {
                    self.currentPage++;
                    self.storeList.push(...json.data);
                    $state.complete();
                  }
                  self.isLoading = false;
                }}`;

            },

            /** 點擊品牌 */
            onClickBrand: function(brandId) {
                if (this.isLogin) {
                    this.$router.push({name: 'BrandInfo', query: {"id": brandId}});
                } else {
                    //沒登入的話就導到登入
                    this.$router.push({name: 'Login'});
                }
            },

            /** 點擊店家 */
            onClickStore: function(storeId) {
                if (this.isLogin) {
                    this.$router.push({name: 'StoreInfo', query: {"id": storeId}});
                } else {
                    //沒登入的話就導到登入
                    this.$router.push({name: 'Login'});
                }
            },

            /** 是否顯示備註 */
            isShowRemark: function(storeInfo) {
                return (storeInfo.title !== undefined &&
                    storeInfo.title !== null &&
                    storeInfo.title !== '' &&
                    storeInfo.notes !== undefined &&
                    storeInfo.notes !== null &&
                    storeInfo.notes.length > 0) ;
            },
            /** 備註 */
            getRemark: function(storeInfo) {
                let result = '';
                if (storeInfo.notes !== undefined &&
                    storeInfo.notes !== null &&
                    storeInfo.notes.length > 0) {
                    storeInfo.notes.forEach(function (value) {
                        if (value !== '') {
                            result = result + '<p>'+ value ;
                        }
                    })
                }
                return result;
            },
        }
    }
</script>

